import React from 'react';
import { Button, Form, Select, message } from 'antd';
//mobx
import { useStore } from '@/store';
import { observer } from 'mobx-react-lite';
import { set, runInAction, toJS } from 'mobx';

const Shedstransducer = () => {
    //mobx
    const { ShedsStore } = useStore()
    // 取消按钮
    const [form] = Form.useForm();
    const { Option } = Select
    //表单提交
    const onFinish = (values) => {

        if (values.sdcode) {
            let a = values.sdcode.split(',')
            values.sdcode = a[0]
        } else {
            message.error('请选择绑定设备')
        }
        ShedsStore.getSubmit(values)
        runInAction(() => {
            set(ShedsStore, { isAshow: false })
            set(ShedsStore, { selectdata:[] })
        })
        form.resetFields();
    };
    //表单取消
    const onReset = () => {
        runInAction(() => {
            set(ShedsStore, { isAshow: false })
            set(ShedsStore, { selectdata:[] })
        })
        form.resetFields();
    };
    return (
        <>
            <Form
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 14,
                }}
                form={form}
                onFinish={onFinish}
                initialValues={{
                    nongjitype: 'dongli'
                }}
            >
                <Form.Item
                    label="设备名称"
                    name="sdcode"
                    rules={[
                        {
                            required: true,
                            message: '请选择设备名称'
                        },
                    ]}
                >
                    <Select
                        placeholder="请选择设备名称"
                    >
                        {
                            ShedsStore.selectdata && (
                                toJS(ShedsStore.selectdata).map((item) => {
                                    return <Option value={item.value} key={item.value}>{item.label}</Option>
                                })
                            )
                        }
                    </Select>
                </Form.Item>

                <Form.Item wrapperCol={{ offset: 6 }}>
                    <Button type="primary" htmlType="submit">
                        提交
                    </Button>
                    <Button htmlType="button" onClick={onReset} style={{ marginLeft: '15px' }}>
                        取消
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}

export default observer(Shedstransducer)